import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'voxerface.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'voxerface',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'voxerface.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
}

/*
 * Initialization is deliberately non-fatal.
 *
 * getAuth() throws synchronously on a missing or invalid API key, and this
 * module sits in the import graph of every route — including the marketing
 * landing page. A throw here means React never mounts and voxerface.com
 * serves a blank screen to cold traffic from the Marketplace ad.
 *
 * Auth is not part of the marketing funnel (the funnel is a phone call), so
 * a broken Firebase config should degrade the /auth and /dashboard routes,
 * not take down the front page.
 */
let app = null
let auth = null
let db = null
let googleProvider = null

try {
  if (!firebaseConfig.apiKey) {
    throw new Error('VITE_FIREBASE_API_KEY is not set')
  }

  app = initializeApp(firebaseConfig)
  auth = getAuth(app)
  db = getFirestore(app)

  googleProvider = new GoogleAuthProvider()
  googleProvider.setCustomParameters({ prompt: 'select_account' })
} catch (error) {
  console.warn(
    '[firebase] Auth unavailable — signed-out routes will still render.',
    error?.message ?? error
  )
}

export const firebaseReady = auth !== null

export { auth, db, googleProvider }
export default app
